/** Lightroom export suffix: `-Edit` or `-Edit-2` right before the extension. */
const EDIT_SUFFIX = /^(.+)-edit(?:-\d+)?(\.[^.]+)$/i;

export interface RetouchPair {
  readonly file: File;
  readonly editName: string;
  readonly originalName: string;
}

/** `photo-1-Edit-2.JPG` → `photo-1.JPG`; null when the name carries no `-Edit` suffix. */
export function stripEditSuffix(name: string): string | null {
  const match = EDIT_SUFFIX.exec(name);
  return match ? match[1] + match[2] : null;
}

/** Pairs `-Edit` files with project photos by the stripped name, case-insensitive; `originalName` keeps the stored spelling. */
export function pairRetouchFiles(files: File[], storedNames: readonly string[]): { pairs: RetouchPair[]; unpaired: File[] } {
  const stored = new Map<string, string>();
  for (const name of storedNames) {
    const key = name.toLowerCase();
    if (!stored.has(key)) stored.set(key, name);
  }

  const pairs: RetouchPair[] = [];
  const unpaired: File[] = [];
  for (const file of files) {
    const stripped = stripEditSuffix(file.name);
    const originalName = stripped === null ? undefined : stored.get(stripped.toLowerCase());
    if (originalName === undefined) unpaired.push(file);
    else pairs.push({ file, editName: file.name, originalName });
  }

  return { pairs, unpaired };
}
